import QRCode from 'qrcode.react';

import styled from 'styled-components';
import { refWidth, refWidthLandscape } from '../../utils/dimensions';
import { mq } from '../../../assets/styles/mediaQuery';

const DOWNLOAD_PATH = '/download';

const ResponsiveSvgWrapper = styled.div`
  svg {
    display: block;
    height: auto;
    width: ${refWidth(110)}vw;

    ${mq.landscape} {
      width: ${refWidthLandscape(110)}vw;
    }
  }
`;

const QRCodeWrapper = () => {
  return (
    <ResponsiveSvgWrapper>
      <QRCode renderAs={'svg'} value={`${window.location.origin}${DOWNLOAD_PATH}`} />
    </ResponsiveSvgWrapper>
  );
};

export default QRCodeWrapper;
